import { Component, OnInit } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { AuthSsoService } from '../services/auth-sso.service';
import { Router } from '@angular/router';

@Component({
  selector: 'ngx-sso-web-login',
  templateUrl: './sso-web-login.component.html',
  styleUrls: ['./sso-web-login.component.scss'],
})
export class SsoWebLoginComponent implements OnInit {
  constructor(
    private _oauthService: OAuthService,
    private _authSsoService: AuthSsoService,
    private _router: Router,
  ) {}

  async ngOnInit() {
    try {
      await this._oauthService.loadDiscoveryDocument();
      await this._oauthService.tryLogin();

      if (this._oauthService.hasValidAccessToken()) {
        this._router.navigate(['/app'], { replaceUrl: true });
      } else {
        this._authSsoService.login();
      }
    } catch (error) {
      console.error('Error saat inisialisasi SSO Web:', error);
      this._router.navigate(['/public-monitor'], { replaceUrl: true });
    }
  }
}
